import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import EntityList from "@/pages/EntityList";
import EntityDetail from "@/pages/EntityDetail";
import Products from "@/pages/Products";
import CashRegisters from "@/pages/CashRegisters";
import InvoicesList from "@/pages/InvoicesList";
import InvoiceForm from "@/pages/InvoiceForm";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Transactions from "@/pages/Transactions";
import Analytics from "@/pages/Analytics";
import ProjectsList from "@/pages/ProjectsList";
import ProjectDetail from "@/pages/ProjectDetail";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import MyJobs from "@/pages/MyJobs";
import Calendar from "@/pages/Calendar";
import Backup from "@/pages/Backup";
import AiPlanner from "@/pages/AiPlanner";

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/projeler" replace />;
  return <Layout>{children}</Layout>;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/projeler" replace />;
  return <Layout><Dashboard /></Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/musteriler" element={<Protected adminOnly><EntityList kind="customer" /></Protected>} />
      <Route path="/musteriler/:id" element={<Protected adminOnly><EntityDetail kind="customer" /></Protected>} />
      <Route path="/tedarikciler" element={<Protected adminOnly><EntityList kind="supplier" /></Protected>} />
      <Route path="/tedarikciler/:id" element={<Protected adminOnly><EntityDetail kind="supplier" /></Protected>} />
      <Route path="/calisanlar" element={<Protected adminOnly><EntityList kind="employee" /></Protected>} />
      <Route path="/calisanlar/:id" element={<Protected adminOnly><EntityDetail kind="employee" /></Protected>} />
      <Route path="/urunler" element={<Protected adminOnly><Products /></Protected>} />
      <Route path="/kasalar" element={<Protected adminOnly><CashRegisters /></Protected>} />
      <Route path="/kasalar/:id" element={<Protected adminOnly><EntityDetail kind="cash_register" /></Protected>} />
      <Route path="/satis-faturalari" element={<Protected adminOnly><InvoicesList kind="sales" /></Protected>} />
      <Route path="/satis-faturalari/yeni" element={<Protected adminOnly><InvoiceForm kind="sales" /></Protected>} />
      <Route path="/satis-faturalari/duzenle/:id" element={<Protected adminOnly><InvoiceForm kind="sales" /></Protected>} />
      <Route path="/satis-faturalari/:id" element={<Protected adminOnly><InvoiceDetail kind="sales" /></Protected>} />
      <Route path="/alis-faturalari" element={<Protected adminOnly><InvoicesList kind="purchase" /></Protected>} />
      <Route path="/alis-faturalari/yeni" element={<Protected adminOnly><InvoiceForm kind="purchase" /></Protected>} />
      <Route path="/alis-faturalari/duzenle/:id" element={<Protected adminOnly><InvoiceForm kind="purchase" /></Protected>} />
      <Route path="/alis-faturalari/:id" element={<Protected adminOnly><InvoiceDetail kind="purchase" /></Protected>} />
      <Route path="/hareketler" element={<Protected adminOnly><Transactions /></Protected>} />
      <Route path="/analiz" element={<Protected adminOnly><Analytics /></Protected>} />
      <Route path="/projeler" element={<Protected><ProjectsList /></Protected>} />
      <Route path="/projeler/:id" element={<Protected><ProjectDetail /></Protected>} />
      <Route path="/ayarlar" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="/yedekleme" element={<Protected adminOnly><Backup /></Protected>} />
      <Route path="/kullanicilar" element={<Protected adminOnly><Users /></Protected>} />
      <Route path="/islerim" element={<Protected><MyJobs /></Protected>} />
      <Route path="/takvim" element={<Protected><Calendar /></Protected>} />
      <Route path="/ai-planlama" element={<Protected adminOnly><AiPlanner /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
